module.exports = __webpack_public_path__ + "static/media/sebastienPost.60e280a1.jpg";